import NewAppointmentModal from './NewAppointmentModal';

export default NewAppointmentModal;
